import styled from "styled-components";
import Headline from "./Headline";
import colors from "../config/colors";
import media from "../config/mediaQueries";

const SubHeadline = Headline.withComponent("h2").extend`
  font-size: 1.5rem;
  font-weight: 500;
  margin: 1rem 0 1rem;
  ${media.desktop`
    font-size: ${({ responsive }) => (responsive ? "2.5vw" : "1.5rem")};
  `};
`;

export default SubHeadline;



// WEBPACK FOOTER //
// ./src/components/SubHeadline.js